var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChiefCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1018 10.8127C15.1018 10.8127 15.285 11.1853 16.0581 10.8127L15.2715 11.9999L14.5763 12.3306L15.1018 10.8127Z",
    fill: "#008AB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57382 10.8127C6.57382 10.8127 6.39067 11.1853 5.61761 10.8127L6.40418 11.9999L7.09943 12.3306L6.57382 10.8127Z",
    fill: "#008AB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3691 7.41878C16.3691 6.87853 15.931 6.44077 15.3907 6.44077C14.8508 6.44077 14.4124 6.87853 14.4124 7.41878C14.4124 7.75408 14.5821 8.04978 14.8395 8.22603C12.5361 14.374 11.5446 8.54481 11.3259 6.92719C11.739 6.74533 9.96889 6.74533 10.382 6.92719C10.1633 8.54481 9.17173 14.374 6.86826 8.22603C7.1258 8.04978 7.29543 7.75407 7.29543 7.41878C7.29543 6.87853 6.8571 6.44077 6.3171 6.44077C5.77685 6.44077 5.33878 6.87853 5.33878 7.41878C5.33878 7.89505 5.68041 8.2912 6.13196 8.37804C6.16815 9.55416 6.33032 12.8426 7.00549 13.6241C7.00549 13.6241 7.63732 14.6668 10.8539 14.6456C14.0705 14.6668 14.7023 13.6241 14.7023 13.6241C15.3775 12.8426 15.5397 9.55415 15.5759 8.37804C16.0274 8.29119 16.3691 7.89504 16.3691 7.41878Z",
    fill: "#008AB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4314 7.20887C13.0441 19.4306 11.5348 4.9834 11.5348 4.9834H10.8541H10.1735C10.1735 4.9834 8.66407 19.4306 4.27684 7.20887L3.25629 7.26126C3.25629 7.26126 3.34929 14.825 4.67612 16.3596C4.67612 16.3596 5.69007 18.0337 10.8541 17.9993C16.0181 18.0337 17.0321 16.3596 17.0321 16.3596C18.3589 14.825 18.4519 7.26126 18.4519 7.26126L17.4314 7.20887Z",
    fill: "url(#paint0_linear_235_10766)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8539 6.44098C11.1596 6.44098 11.4475 6.36647 11.7029 6.2371C11.5876 5.49175 11.5346 4.9834 11.5346 4.9834H10.8539H10.1732C10.1732 4.9834 10.1201 5.4918 10.0049 6.2371C10.2603 6.36647 10.5481 6.44098 10.8539 6.44098Z",
    fill: "#0F7BCA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8881 7.26167C17.8881 7.26167 17.795 14.8254 16.4682 16.36C16.4682 16.36 15.4888 17.9713 10.5721 17.9988C10.6655 17.9994 10.7576 18.0003 10.8538 17.9997C16.0178 18.0341 17.0317 16.36 17.0317 16.36C18.3586 14.8254 18.4515 7.26166 18.4515 7.26166H17.8881V7.26167Z",
    fill: "#0F7BCA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08085 11.8663C6.77701 12.5061 5.43494 10.4367 4.27637 7.20892L3.72318 7.23734C5.17172 11.2625 6.92224 12.8472 8.08085 11.8663Z",
    fill: "url(#paint1_linear_235_10766)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5891 11.8663C14.8929 12.5061 16.2351 10.4367 17.3936 7.20892L17.9468 7.23734C16.4982 11.2625 14.7477 12.8472 13.5891 11.8663Z",
    fill: "url(#paint2_linear_235_10766)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7381 3.88413C12.7381 4.92461 11.8941 5.76845 10.8538 5.76845C9.81341 5.76845 8.96945 4.92463 8.96945 3.88413C8.96945 2.84381 9.8134 1.99994 10.8538 1.99994C11.894 1.99994 12.7381 2.84381 12.7381 3.88413Z",
    fill: "url(#paint3_radial_235_10766)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0163 8.30694C17.3014 8.59792 17.6982 8.77899 18.1375 8.77899C18.2285 8.77899 18.3171 8.76956 18.4039 8.7547C18.4441 7.85992 18.4515 7.26119 18.4515 7.26119L17.431 7.2088C17.2898 7.60216 17.1516 7.96743 17.0163 8.30694Z",
    fill: "#0F7BCA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7079 6.39747C19.7079 7.26441 19.0045 7.96769 18.1376 7.96769C17.2706 7.96769 16.5673 7.26441 16.5673 6.39747C16.5673 5.53053 17.2707 4.82733 18.1376 4.82733C19.0045 4.82733 19.7079 5.53054 19.7079 6.39747Z",
    fill: "url(#paint4_radial_235_10766)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27684 7.2088L3.25629 7.26119C3.25629 7.26119 3.2635 7.8448 3.30225 8.72004C3.43653 8.75744 3.57746 8.77899 3.7236 8.77899C4.1082 8.77899 4.46012 8.64014 4.7332 8.41047C4.58463 8.04191 4.43263 7.64275 4.27684 7.2088Z",
    fill: "#0F7BCA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99994 6.39747C1.99994 7.26441 2.70323 7.96769 3.57016 7.96769C4.43711 7.96769 5.14043 7.26441 5.14043 6.39747C5.14043 5.53053 4.4371 4.82733 3.57016 4.82733C2.70324 4.82733 1.99994 5.53054 1.99994 6.39747Z",
    fill: "url(#paint5_radial_235_10766)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3998 15.2709C17.3998 15.2709 16.3253 17.045 10.8538 17.0088C5.38233 17.045 4.30782 15.2709 4.30782 15.2709C4.2013 15.1483 4.10685 14.9807 4.01501 14.7926C4.19157 15.4845 4.40743 16.0489 4.67582 16.3595C4.67582 16.3595 5.68977 18.0336 10.8538 17.9992C16.0178 18.0336 17.0318 16.3595 17.0318 16.3595C17.3002 16.0489 17.5161 15.4845 17.6926 14.7926C17.6007 14.9807 17.5063 15.1483 17.3998 15.2709Z",
    fill: "url(#paint6_linear_235_10766)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30782 15.5465C4.30782 15.5465 5.38233 17.3206 10.8538 17.2844C16.3253 17.3206 17.3998 15.5465 17.3998 15.5465C17.442 15.498 17.4819 15.4409 17.5209 15.3795C17.5818 15.1974 17.6392 15.0017 17.6926 14.7926C17.6007 14.9807 17.5063 15.1483 17.3998 15.2709C17.3998 15.2709 16.3253 17.045 10.8538 17.0088C5.38233 17.045 4.30782 15.2709 4.30782 15.2709C4.2013 15.1483 4.10685 14.9807 4.01501 14.7926C4.06841 15.0017 4.12579 15.1974 4.18666 15.3795C4.22572 15.4409 4.26564 15.498 4.30782 15.5465Z",
    fill: "#33BDE8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36925 15.7885C4.36925 15.7885 5.43371 17.5459 10.8539 17.5101C16.2741 17.5459 17.3386 15.7885 17.3386 15.7885C17.3803 15.7404 17.4199 15.6838 17.4586 15.623C17.5188 15.4426 17.5757 15.2488 17.6286 15.0417C17.5376 15.228 17.444 15.3941 17.3386 15.5155C17.3386 15.5155 16.2742 17.273 10.8539 17.2371C5.43373 17.273 4.36926 15.5155 4.36926 15.5155C4.26373 15.3941 4.17017 15.228 4.07919 15.0417C4.13211 15.2488 4.18893 15.4426 4.24923 15.623C4.28793 15.6838 4.32745 15.7404 4.36925 15.7885Z",
    fill: "url(#paint7_linear_235_10766)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_10766",
    x1: 3.25629,
    y1: 11.4916,
    x2: 18.4519,
    y2: 11.4916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1961,
    stopColor: "#0097C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3569,
    stopColor: "#1A86EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#25ADF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    stopColor: "#1DAAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    stopColor: "#16E0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    stopColor: "#0A93E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_235_10766",
    x1: 7.62276,
    y1: 12.3891,
    x2: 3.94533,
    y2: 7.79229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A79E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    stopColor: "#16A9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3804,
    stopColor: "#1DAAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8078,
    stopColor: "#1AB8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_235_10766",
    x1: 14.092,
    y1: 12.3346,
    x2: 17.6212,
    y2: 7.91573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0067C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    stopColor: "#1A9FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#1D90FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8275,
    stopColor: "#1672FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A79E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_235_10766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9131 2.93518) scale(2.72868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#00BFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076B8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_235_10766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1079 5.62644) scale(2.2104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#00BFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076B8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_235_10766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.57019 5.50781) scale(2.42225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21BAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#00A1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_235_10766",
    x1: 4.01502,
    y1: 16.3962,
    x2: 17.6926,
    y2: 16.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1961,
    stopColor: "#0073B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#48AFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    stopColor: "#49BBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_235_10766",
    x1: 4.07918,
    y1: 16.2761,
    x2: 17.6286,
    y2: 16.2761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    stopColor: "#169BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3804,
    stopColor: "#1DD2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6588,
    stopColor: "#007FC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AB8EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiefCrown);
export default __webpack_public_path__ + "static/media/chief-crown.d1ba32c91321f76e9a0a14bc4d8b4804.svg";
export { ForwardRef as ReactComponent };